'use es6';

import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import tracker from '../lib/usage/publicTracker';
import Application from '../App';
var i18nProvider = createPublicI18nProvider();
new Application({
  i18nProvider: i18nProvider,
  tracker: tracker
}).start(false);